import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

export default function CustomRichTextField(props) {
  return(
    <>
     <span style={{color:'#80949D'}}>{props?.label}</span>
      <Editor
        apiKey="k812dgua94sdi38rxfd2bbih71x3fs13iue3q5pt8nx9r8cl"
        initialValue={props?.value || "<p></p>"}
        init={{
          height: 200,
          menubar: true,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar:
            'undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help'
        }}
        onEditorChange={props?.onChange}
      />
      </>
    );
  }
  // handleEditorChange = (content, editor) => {
  //   console.log('Content was updated:', content);
  // }


